import React from 'react';
import { Divider, Typography, Box, Chip } from '@mui/material';

const StyledDateDivider = ({ date }) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginY: 1,
      position: 'relative'
    }}>
      <Divider sx={{ width: '100%', '&::before, &::after': { borderColor: '#dcdcdc' } }} >
      <Chip
        label={
          <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#555', fontSize: '0.75rem' }}>
            {date.toUpperCase()}
          </Typography>
        }
        sx={{
          backgroundColor: '#f7f7f7',
          border: 'none',
          height: 'auto',
          fontSize: '10px',
          paddingX: '10px',
          boxShadow: '0px 2px 5px rgba(0,0,0,0.10)',
        }}
        />
        </Divider>
    </Box>
  );
};

export default StyledDateDivider;
